import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';
import Spacing from '../../../v2/style-helper/Spacing';

export default createUseStyles({
  createAccount: props => (props.isNewGuestUpdatedPage && {
    padding: Spacing.double,
    width: props.siteId ? '40%' : '60%',
    
    [MediaQueries.phone]: {
      width: '100%',
    },
  }),
});
